import luhn from "./luhn_algorithm";

const utils = {
  validateEmail(email) {
    const re = /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;
    const regAfterAtSign = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return (
      re.test(String(email).toLowerCase()) &&
      regAfterAtSign.test(String(email).toLowerCase())
    );
  },

  validateString(string) {
    if (!string) {
      return false;
    }
    return string.length >= 3;
  },

  validateUserName(string) {
    if (!string) {
      return false;
    }
    return string.length >= 4;
  },
  
  validatePassword(pw) {
    if (!pw) {
      return false;
    }
    return pw.length >= 4;
  },

  validatePIN(pin) {
    if (!pin) {
      return false;
    }
    return /^\d{4}$/.test(pin);
  },

  validateType(type) {
    return type !== null;
  },

  validateEmptySelect(value) {
    return !(!value || value.length === 0);
  },

  validateIMEI(imei) {
    if (!imei) {
      return false;
    }
    return luhn.luhn_validate(imei);
  },

  errorHandler(error) {
    if (error && error.response) {
      let code = error.response.status
        ? error.response.status
        : error.response.status_code;
      let errorData = error.response.data;

      let errorMessage;
      if (errorData.hasOwnProperty("message")) {
        errorMessage = errorData.message;
      } else {
        errorMessage = errorData.data;
      }

      let finalErrorMessage;

      if (code === 422 && errorMessage.errors) {
        return errorMessage.errors;
      } else if (code === 429) {
        finalErrorMessage = "The server is busy. Please try again later.";
      } else if (typeof errorMessage === "string") {
        finalErrorMessage = errorMessage;
      } else {
        finalErrorMessage = "An error occurred. Please try again later.";
      }

      return finalErrorMessage;
    }
  }
};

export default utils;



// WEBPACK FOOTER //
// ./src/utils/index.js